<div class="w-full space-y-6">

    <!-- Page Header -->
    <div class="flex items-center justify-between pb-4 border-b border-slate-200">
        <div class="flex items-center gap-3">
            <div class="h-10 w-10 bg-slate-100 rounded-lg flex items-center justify-center">
                <mat-icon class="text-slate-600">campaign</mat-icon>
            </div>
            <div>
                <h2 class="text-sm font-bold tracking-widest uppercase text-slate-800">
                    Promotional SMS Scheduler
                </h2>
                <p class="text-xs text-slate-500 font-medium mt-0.5">
                    Schedule and manage promotional SMS messages
                </p>
            </div>
        </div>
    </div>

    <!-- FORM CARD -->
    <div class="bg-white rounded-lg shadow border border-slate-200 px-6 py-4">
        <div class="flex flex-col md:flex-row flex-wrap items-start md:items-center gap-4 md:gap-6 w-full">

            <!-- Customer -->
            <mat-form-field appearance="outline" class="w-full md:w-72">
                <mat-label>Customer Name</mat-label>
                <mat-icon matPrefix class="text-slate-500">person</mat-icon>
                <mat-select name="customerId" [(ngModel)]="l_formData.customerId" required #customerId="ngModel">
                    <mat-option *ngFor="let c of customerList" [value]="c.customerId">
                        {{ c.customerName }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Template -->
            <mat-form-field appearance="outline" class="w-full md:flex-1">
                <mat-label>Template</mat-label>
                <mat-icon matPrefix class="text-slate-500 mr-2">dashboard</mat-icon>
                <mat-select name="templateId" [(ngModel)]="l_formData.templateId" required #templateId="ngModel">
                    <mat-option *ngFor="let template of l_templatesList" [value]="template.templateId"
                        matTooltip="{{ template.templateName }} - {{ template.templateMsg }}">
                        <span class="block truncate">
                            {{ template.templateName }}
                        </span>
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="templateId.invalid">
                    Please select template
                </mat-error>
            </mat-form-field>

            <!-- Schedule SMS Date -->
            <mat-form-field appearance="outline" class="w-full md:w-56">
                <mat-label>Schedule Promo SMS Date</mat-label>
                <mat-icon matPrefix class="text-slate-500">event</mat-icon>
                <input matInput [matDatepicker]="promoSmsScheduledOn" name="promoSmsScheduledOn"
                    [(ngModel)]="l_formData.promoSmsScheduledOn" required>
                <mat-datepicker-toggle matSuffix [for]="promoSmsScheduledOn"></mat-datepicker-toggle>
                <mat-datepicker #promoSmsScheduledOn></mat-datepicker>
            </mat-form-field>

            <!-- Active -->
            <div class="flex items-center h-auto md:h-[56px] w-full md:w-auto">
                <mat-checkbox [(ngModel)]="l_formData.isActive">
                    <span class="text-[12px] font-semibold tracking-widest uppercase text-slate-700">
                        Active
                    </span>
                </mat-checkbox>
            </div>

            <!-- Buttons -->
            <div class="flex items-center justify-end w-full md:w-auto gap-3 shrink-0 md:ml-auto">
                <button (click)="lFN_ResetForm();" class="flex-1 md:flex-none px-6 py-2.5 rounded-lg
                    text-slate-500 text-[12px] font-medium tracking-widest uppercase
                    bg-slate-100 text-slate-900
                    transition-all duration-200">
                    {{ 'Reset' }}
                </button>
                <button (click)="lFN_SubmitForm();" class="px-6 py-2 rounded-md
                    bg-gradient-to-r from-slate-900 to-black
                    text-white text-[12px] font-medium tracking-widest uppercase
                    shadow hover:from-black hover:to-slate-800
                    transition-all duration-150 whitespace-nowrap">
                    {{ 'Submit' }}
                </button>
            </div>

        </div>
    </div>

  <!-- TABLE CARD -->
  <div class="bg-white rounded-lg shadow border border-slate-200">
    <div class="overflow-x-auto w-full">
      <table mat-table [dataSource]="dataSource" class="w-full whitespace-nowrap">

      <!-- Customer Name -->
      <ng-container matColumnDef="customerName">
        <th mat-header-cell *matHeaderCellDef class="bg-gray-900 text-white uppercase text-xs">
          Customer Name
        </th>
        <td mat-cell *matCellDef="let t" class="text-sm">
          {{ t.customerName }}
        </td>
      </ng-container>

      <!-- Template Name -->
      <ng-container matColumnDef="templateName">
        <th mat-header-cell *matHeaderCellDef class="bg-gray-900 text-white uppercase text-xs">
          Template Name
        </th>
        <td mat-cell *matCellDef="let t" class="text-sm">
          {{ t.templateName }}
        </td>
      </ng-container>

      <!-- SMS Send Date -->
      <ng-container matColumnDef="promoSmsScheduledOn">
        <th mat-header-cell *matHeaderCellDef class="bg-gray-900 text-white uppercase text-xs">
          Promo SMS Send Date
        </th>
        <td mat-cell *matCellDef="let t" class="text-sm">
          {{ t.promoSmsScheduledOn }}
        </td>
      </ng-container>      

      <!-- Status -->
      <ng-container matColumnDef="isActive">
        <th mat-header-cell *matHeaderCellDef class="bg-gray-900 text-white uppercase text-xs">
          Status
        </th>
        <td mat-cell *matCellDef="let t">
          <button (click)="lFN_ChangePromoSmsStatus(t);" class="w-20 text-center
                  px-0 py-1.5 rounded-full text-[10px] font-semibold tracking-widest uppercase
                  transition-all duration-200 border" [ngClass]="t.isActive === 'YES'
                  ? 'bg-emerald-200 text-emerald-900 border border-emerald-600 hover:bg-emerald-300'
                  : 'bg-rose-200 text-rose-900 border border-rose-600 hover:bg-rose-300'">

            {{ t.isActive === 'YES' ? 'Active' : 'Inactive' }}
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>
    </div>

    <mat-paginator [pageSizeOptions]="[10,20,30]" showFirstLastButtons></mat-paginator>

  </div>    

</div>